import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safe',
})
export class SafePipe implements PipeTransform {
  constructor(private _domSanitizer: DomSanitizer) {}

  transform(value: string, type?: 'url' | 'html'): any {
    if (value) {
      switch (type) {
        case 'url':
          return this._domSanitizer.bypassSecurityTrustResourceUrl(value);
        case 'html':
          return this._domSanitizer.bypassSecurityTrustHtml(value);
      }
    }

    return null;
  }
}
